module.exports = __webpack_public_path__ + "files/5822bb7d3c899ea63af37fcc0216214d.png";